/**
 * Category field'ına göre data array'ini alfabetik olarak sıralar
 * Performans için memoization ve efficient sorting kullanır
 */

import { useMemo } from "react";

/**
 * Standalone sorting function - hook olmayan durumlarda kullanılır
 * @param data - Sıralanacak data array'i
 * @param categoryField - Category field adı (default: 'category')
 * @returns Alfabetik olarak sıralanmış data array'i
 */
export const sortByCategory = <T extends Record<string, any>>(data: T[], categoryField: string = "category"): T[] => {
  if (!data || data.length === 0) return data;

  // Shallow copy oluştur ve sırala
  return [...data].sort((a, b) => {
    const categoryA = (a[categoryField] || "").toString().toLowerCase();
    const categoryB = (b[categoryField] || "").toString().toLowerCase();
    return categoryA.localeCompare(categoryB);
  });
};

/**
 * React hook - component içinde memoized sorting için kullanılır
 * @param data - Sıralanacak data array'i
 * @param categoryField - Category field adı (default: 'category')
 * @returns Memoized sorted data array'i
 */
export const useSortedByCategory = <T extends Record<string, any>>(
  data: T[],
  categoryField: string = "category"
): T[] => {
  return useMemo(() => {
    return sortByCategory(data, categoryField);
  }, [data, categoryField]);
};
